/* These lines of code are defining constants for action types in a Redux application. */
export const LIST_ALL_USER_NOTIFY_SUCCESS = 'LIST_ALL_USER_NOTIFY_SUCCESS';
export const LIST_ALL_USER_NOTIFY_REQUEST = 'LIST_ALL_USER_NOTIFY_REQUEST';
export const LIST_ALL_USER_NOTIFY_FAILURE = 'LIST_ALL_USER_NOTIFY_FAILURE';
export const UPDATE_USER_NOTIFY = 'UPDATE_USER_NOTIFY';
